import { ReactNode } from 'react';

interface SettingsSectionProps {
  title: string;
  description?: string;
  children: ReactNode;
  icon?: ReactNode;
}

export default function SettingsSection({ title, description, children, icon }: SettingsSectionProps) {
  return (
    <div className="space-y-6 animate-fade-in">
      <div className="flex items-start gap-3">
        {icon && (
          <div className="p-2 bg-recipe-accent/10 rounded-lg text-recipe-accent">
            {icon}
          </div>
        )}
        <div className="flex-1">
          <h2 className="text-xl font-bold text-recipe-text mb-1">{title}</h2>
          {description && (
            <p className="text-sm text-recipe-text-muted">{description}</p>
          )}
        </div>
      </div>

      <div className="space-y-6">
        {children}
      </div>
    </div>
  );
}
